import { RhfTextField } from './fields';

export type ProfileFormValues = {
  firstName: string;
  lastName: string;
  username: string;
  email: string;
  phone: string;
};

export function getProfileDefaultValues(
  user?: {
    firstName?: string;
    lastName?: string;
    username?: string;
    email?: string;
    phone?: string | null;
  } | null
): ProfileFormValues {
  return {
    firstName: user?.firstName ?? '',
    lastName: user?.lastName ?? '',
    username: user?.username ?? '',
    email: user?.email ?? '',
    phone: user?.phone ?? '',
  };
}

export function toProfilePayload(data: ProfileFormValues) {
  return {
    firstName: data.firstName.trim(),
    lastName: data.lastName.trim(),
    username: data.username.trim(),
    email: data.email.trim(),
    phone: data.phone.trim() || undefined,
  };
}

function ProfileForm() {
  return (
    <>
      <RhfTextField<ProfileFormValues>
        name="firstName"
        label="First name"
        required
      />
      <RhfTextField<ProfileFormValues>
        name="lastName"
        label="Last name"
        required
      />
      <RhfTextField<ProfileFormValues>
        name="username"
        label="Username"
        required
      />
      <RhfTextField<ProfileFormValues>
        name="email"
        label="Email"
        textFieldProps={{ type: 'email' }}
        required
      />
      <RhfTextField<ProfileFormValues> name="phone" label="Phone" />
    </>
  );
}

export default ProfileForm;
